<template>
  <nly-content-wrapper>
    <nly-breadcrumb>
      <nly-breadcrumb-item text="Matérias" to="materias" />
      <nly-breadcrumb-item text="Aulas" active />
      <!-- <nly-breadcrumb-item text="alunos"  active />  -->
    </nly-breadcrumb>
    <div class="row justify-content-md-center">
      <div class="col-8">
        <nly-card class="text-center">
          <b-button-group>
            <b-button variant="outline-primary">
              <h5>
                <b-icon icon="archive-fill"></b-icon>
              </h5>Programa
            </b-button>

            <b-button variant="outline-primary">
              <h5>
                <b-icon icon="chat-square-fill"></b-icon>
              </h5>Forum
            </b-button>
            <b-button @click="showModalChat()" variant="outline-primary">
              <h5>
                <b-icon icon="chat-dots-fill"></b-icon>
              </h5>Chat
            </b-button>
            <b-button variant="outline-primary">
              <h5>
                <b-icon icon="card-heading"></b-icon>
              </h5>Trabalhos
            </b-button>
            <b-button variant="outline-primary">
              <h5>
                <b-icon icon="bookmark-check"></b-icon>
              </h5>Avaliações
            </b-button>
          </b-button-group>
        </nly-card>
      </div>
    </div>

    <div class="row justify-content-md-center">
      <div class="col-md-4 col-lg-4 col-xs-12">
        <div class="card text-center">
          <b-button @click="buscar_aulas('1')" variant="outline-primary">
            <h3>1º Parcial</h3>
          </b-button>
        </div>
      </div>

      <div class="col-md-4 col-lg-4 col-xs-12">
        <div class="card text-center">
          <b-button @click="buscar_aulas('2')" variant="outline-primary">
            <h3>2º Parcial</h3>
          </b-button>
        </div>
      </div>
    </div>

    <!-- <div class="row justify-content-md-center">
      <div class="col-md-8 col-lg-8 col-xs-12">
        <nly-card>
            <nly-button variant="primary" v-nly-toggle.collapseTest1 block>Aula 1</nly-button>
        </nly-card>
        <nly-collapse id="collapseTest1">
            <nly-card>
            <b-button variant="outline-primary">
                <h6>VIDEO - LAS MAIORES COISA QUE ACONTECEU</h6>
            </b-button>
            <b-button variant="outline-primary">
                <h5>PDF - PDF PARA O PROFESSOR</h5>
            </b-button>
            </nly-card>
        </nly-collapse>
      </div>
    </div>-->

    <nly-content>
      <nly-row>
        <nly-col>
          <div class="container col-md-6 col-lg-6 col-xs-12">
            <div v-for="(lista,index) in Aulas" :key="index" class="callout callout-warning row">
              <div class="col-md-9 col-xs-9">
                <!-- <h5>Aula {{lista.id}}</h5> -->
                <p>Aula {{lista.titulo}} - {{lista.nome_professor}}</p>
              </div>
              <div class="col-md-3 col-xs-3">
                <button @click="Router(lista)" class="bt btn-primary">Visualizar</button>
              </div>
            </div>
          </div>
        </nly-col>
      </nly-row>

      <!-- inicia chat -->
      <nly-modal ref="modalChat" size="lg" title="Chat">
        <nly-content>
          <nly-row>
            <nly-col>
              <nly-timeline inverse>
               
                    <!-- <nly-timeline-label bg-variant="info">2019.12.13</nly-timeline-label> -->
                    <nly-timeline-content v-for="(lista,index) in AllMensagensChat" :key="index" icon="far nlyfont nly-icon-logo-ionitron" bg-variant="info">
                    <nly-timeline-item :time="lista.created" time-icon="fas fa-clock">
                        <nly-timeline-header>
                        <nly-link>{{lista.usuarios_nome}}</nly-link>
                        </nly-timeline-header>
                        <nly-timeline-body>{{lista.mensagem}}</nly-timeline-body>
                       
                    </nly-timeline-item>
                    </nly-timeline-content>
               
               
          
              </nly-timeline>
              <div class="text-center">
                <textarea v-model="mensagem_chat" class="form-control"></textarea>
                <br />
                <button @click="Enviar_mensagem_chat()" class="btn btn-primary">Enviar</button>
              </div>
            </nly-col>
          </nly-row>
        </nly-content>
      </nly-modal>
      <!-- termina modal chat -->
    </nly-content>
  </nly-content-wrapper>

  <!-- inicia modal -->
</template>

<script>
export default {
  data() {
    return {
      Materias: [],
      mensagem_chat: ""
    };
  },
  created() {
    //   this.Voltar()
  },
  computed: {
    Aulas() {
      return this.$store.state.aulas.GetAulas;
    },
    DadosMateria() {
      return this.$store.state.aulas.DadosMateria;
    },
    AllMensagensChat() {
      return this.$store.state.mensagens.MensagensChat;
    }
  },
  methods: {
    buscar_aulas(value) {
      let env = {
        parcial: value,
        id: this.DadosMateria.id
      };
      this.$store.dispatch("GetAulas", env);
    },
    Router(value) {
      this.$store.dispatch("SetDadosAula", value);
      this.$store.dispatch("AllArquivos", value);
      this.$router.push({ name: "estudos" });
    },
    Voltar() {
      if (this.$store.state.aulas.DadosMateria == false) {
        this.$router.push({ name: "materias" });
      }
    },
    Enviar_mensagem_chat() {
      var a = {
        mensagem: this.mensagem_chat,
        usuarios_id: 2160,
        oferta_disciplina_id: this.$store.state.aulas.DadosMateria.id,
      };
      this.$store.dispatch("EnviarMensagemChat", a);
      this.mensagem_chat = '';
    },
    BuscarMensagens() {
      var a = {
        usuarios_id: 2160,
        oferta_disciplina_id: this.$store.state.aulas.DadosMateria.id,
      };
      this.$store.dispatch("BuscarMensagensChat", a);
     
    },
    showModalChat() {
      this.$refs["modalChat"].show();
      this.BuscarMensagens();
    },
    hideModalChat() {
      this.$refs["modalChat"].hide();
    }
  }
};
</script>
